<h1 mat-dialog-title>
  {{ data.title }}
  <mat-icon mat-dialog-close>clear</mat-icon>
</h1>

<mat-dialog-content>
  <p [innerHtml]="data.message"></p>
  <mat-radio-group class="visit-options" (change)="selected = $event.value">
    <mat-radio-button *ngFor="let option of data.options" [value]="option">
      {{ option.label }}
      <span class="visit-option-description" *ngIf="option.description">{{ option.description }}</span>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button color="basic" [mat-dialog-close]="undefined">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!selected" [mat-dialog-close]="selected?.value">
    {{ data.confirmLabel }}
  </button>
</mat-dialog-actions>
